import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Button from "../../atoms/button/button";
import { ReferenciaPlantillaContenido } from "../../../interfaces/ReferenciaPlantillaContenido";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

import "./contentRotatorElement.scss";
import { GatsbyImage } from "gatsby-plugin-image";

interface ContentRotatorElementProps {
  contentful_id: string;
  tipoComponente: string;
  titulo: string;
  tituloBoton: string;
  redireccionBoton: string | null;
  descripcion: { json: any };
  imagenPrincipal: {
    title: string;
    file: {
      url: string;
      fileName: string;
    };
    fluid: any;
  };
  tituloGeneral: string;
  autoresArticulo: Array<any>;
  referenciaTabsContenido: Array<{
    titulo: string;
    nombreTab: string;
    like: number;
    imagenLibro: {
      title: string;
      file: {
        url: string;
        fileName: string;
      };
      gatsbyImageData: any;
    };
  }> | null;
  referenciaPlantillaContenido: Array<ReferenciaPlantillaContenido>;
  gtmClass: string;
}

const ContentRotatorElement = (props: ContentRotatorElementProps) => {
  const {
    tituloBanner,
    tituloBoton,
    tituloDescripcion,
    redireccionBoton,
    descripcion,
    imagenPrincipal,
  } = props.referenciaPlantillaContenido[0];

  return (
    <article className="m-content-rotator-element">
      {imagenPrincipal[0].gatsbyImageData ?
        <GatsbyImage
          className="m-content-rotator-element__content__cover"
          image={imagenPrincipal[0].gatsbyImageData}
          alt={imagenPrincipal[0].title || `Imagen ${tituloBanner}`}
        />
        :
        <img
          className="m-content-rotator-element__content__cover"
          src={imagenPrincipal[0].file.url}
          alt={imagenPrincipal[0].title || `Imagen ${tituloBanner}`}
        />
      }
      <div className="m-content-rotator-element__background">
        <article className="m-content-rotator-element__content__text">
          <p className="m-content-rotator-element__content__text__type">
            {tituloDescripcion}
          </p>
          <h3 className="m-content-rotator-element__content__text__title">
            {tituloBanner}
          </h3>
          <div className="m-content-rotator-element__content__text__description">
            {documentToReactComponents(descripcion.json)}
          </div>
          <div className="m-content-rotator-element__content__text__action">
            <Button
              type="link"
              href={redireccionBoton}
              classname={"primary " + imagenPrincipal[0].title}
              text={tituloBoton}
              isDisabled={false}
              gtmMark={`gtm${props.gtmClass}${normalizeTwoWords(
                tituloBanner
              )}${normalizeTwoWords(tituloBoton)}`}
            />
          </div>
        </article>
      </div>
    </article>
  );
};

export default ContentRotatorElement;
